module.exports = __webpack_public_path__ + "img/eptv.487d342a.png";